var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.329,
    height: 34.331,
    viewBox: "0 0 34.329 34.331",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ig",
    transform: "translate(-278.046 -2.144)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_140",
    "data-name": "Path 140",
    d: "M140.373,4.042c4.583,0,5.125.018,6.937.1a9.516,9.516,0,0,1,3.186.591,5.324,5.324,0,0,1,1.975,1.284,5.316,5.316,0,0,1,1.284,1.972,9.52,9.52,0,0,1,.591,3.189c.081,1.81.1,2.351.1,6.935s-.018,5.127-.1,6.937a9.5,9.5,0,0,1-.591,3.186A5.681,5.681,0,0,1,150.5,31.5a9.516,9.516,0,0,1-3.186.591c-1.81.083-2.354.1-6.937.1s-5.127-.016-6.937-.1a9.517,9.517,0,0,1-3.186-.591,5.681,5.681,0,0,1-3.259-3.259,9.5,9.5,0,0,1-.591-3.186c-.081-1.81-.1-2.354-.1-6.937s.018-5.125.1-6.935a9.52,9.52,0,0,1,.591-3.189,5.686,5.686,0,0,1,3.259-3.256,9.517,9.517,0,0,1,3.186-.591c1.812-.083,2.354-.1,6.937-.1m0-3.092c-4.662,0-5.247.02-7.077.1a12.588,12.588,0,0,0-4.166.8,8.779,8.779,0,0,0-5.021,5.021,12.6,12.6,0,0,0-.8,4.166c-.084,1.832-.1,2.417-.1,7.077s.018,5.247.1,7.079a12.6,12.6,0,0,0,.8,4.166,8.767,8.767,0,0,0,5.021,5.019,12.524,12.524,0,0,0,4.166.8c1.83.083,2.415.1,7.077.1s5.247-.02,7.077-.1a12.524,12.524,0,0,0,4.166-.8,8.767,8.767,0,0,0,5.021-5.019,12.606,12.606,0,0,0,.8-4.166c.083-1.832.1-2.417.1-7.079s-.018-5.245-.1-7.077a12.606,12.606,0,0,0-.8-4.166,8.779,8.779,0,0,0-5.021-5.021,12.587,12.587,0,0,0-4.166-.8c-1.83-.083-2.415-.1-7.077-.1",
    transform: "translate(154.837 1.194)",
    fill: "#2ca17f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_141",
    "data-name": "Path 141",
    d: "M135.724,4.651a8.814,8.814,0,1,0,8.815,8.812,8.813,8.813,0,0,0-8.815-8.812m0,14.535a5.722,5.722,0,1,1,5.723-5.723,5.721,5.721,0,0,1-5.723,5.723",
    transform: "translate(159.487 5.845)",
    fill: "#2ca17f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_142",
    "data-name": "Path 142",
    d: "M138.083,5.644a2.06,2.06,0,1,1-2.06-2.06,2.061,2.061,0,0,1,2.06,2.06",
    transform: "translate(168.35 4.504)",
    fill: "#2ca17f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIg);
export default __webpack_public_path__ + "static/media/ig.a2eb3bc1c625cd39a40ab0c6f21b3026.svg";
export { ForwardRef as ReactComponent };